/** @param {string} id */
export function isChineseLocale(id) {
  return id === 'zh' || id === 'zh-TW'
}

/** @param {string} id */
export function intlLocaleFor(id) {
  if (id === 'zh') return 'zh-CN'
  if (id === 'zh-TW') return 'zh-TW'
  return 'en-US'
}

/** Minimal zh → zh-TW for runtime strings not in data.mjs (e.g. wallet errors) */
const PHRASES = [
  ['操作失败，请稍后重试', '操作失敗，請稍後重試'],
  ['主网币余额不足，无法支付手续费', '主網幣餘額不足，無法支付手續費'],
  ['Gas 不足或 Gas 上限过低', 'Gas 不足或 Gas 上限過低'],
  ['交易序号异常，请稍后再试', '交易序號異常，請稍後再試'],
  ['有待确认交易或重复提交，请稍后再试', '有待確認交易或重複提交，請稍後再試'],
  ['合约执行未通过', '合約執行未通過'],
  ['网络异常，请稍后重试', '網路異常，請稍後重試'],
]

const CHARS = {
  请: '請', 稍后: '稍後', 后: '後', 失败: '失敗', 确认: '確認', 网络: '網路',
  余额: '餘額', 无法: '無法', 手续费: '手續費', 过: '過', 低: '低', 异: '異',
  常: '常', 重复: '重複', 合约: '合約', 执行: '執行', 未: '未', 通过: '通過',
  钱包: '錢包', 关闭: '關閉', 本次: '本次', 签名: '簽署', 序号: '序號', 交易: '交易',
}

export function toTraditional(text) {
  if (!text) return text
  let out = text
  for (const [from, to] of PHRASES) out = out.split(from).join(to)
  return [...out].map((ch) => CHARS[ch] || ch).join('')
}
